import { create } from "zustand";
import APIs from "../apis";
import { Item, MenuCategory } from "../types/item";

interface MenuState {
  categories: MenuCategory[] | null;
  cartSuggestions: Item[];
  loading: boolean;
  load: () => Promise<void>;
}

let request: Promise<void> | null = null;

const useMenuStore = create<MenuState>((set, get) => ({
  categories: null,
  cartSuggestions: [],
  loading: true,
  load: () => {
    if (get().categories !== null) return Promise.resolve();
    if (request) return request;
    if (!get().loading) set({ loading: true });
    request = APIs.menu
      .menu()
      .then((menu) => {
        set({
          categories: menu.categories,
          cartSuggestions: menu.cartSuggestions || [],
          loading: false,
        });
      })
      .catch((error) => {
        set({ loading: false });
        throw error;
      })
      .finally(() => {
        request = null;
      });
    return request;
  },
}));

export default useMenuStore;
